export enum HeaderType {
  Index,
  Icon,
  NoHeader,
}
